// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1omWQ","productName":"Table_productName__1GW0W"};